<template>
    <div class="px-0">
        <div class="mb-6">
            <p class="text-lg font-semibold font-inter">
                Edit Purchase Order
            </p>
        </div>
        <div class="bg-white pt-4 pb-8 px-4 rounded-md shadow-md mb-8">
            <div class="grid grid-cols-12 w-3/5 min-w-fit gap-x-8 gap-y-6 ">
                <div class="col-span-4">
                    <label for="" class="label-form mb-3">
                        Date
                    </label>
                    <input type="date" v-model="date" class="input-ui">
                </div>
                <div class="col-span-4">
                    <label for="" class="label-form mb-3">
                        Type
                    </label>
                    <div class="bg-white mb-0 w-full text-sm inline-block h-[34px]"
                        data-te-select-wrapper-ref>
                        <select data-te-select-init data-te-select-placeholder="Select Type"
                            data-te-select-filter="true" name="" id="" v-model="selectedType" class="input-ui">
                            <option :value="type" v-for="(type, typeIndex) in typeList" :key="typeIndex">
                                {{ type.name }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-span-4" v-if="selectedType && selectedType.value === 'event'">
                    <label for="" class="label-form mb-3">
                        Event
                    </label>
                    <div class="bg-white mb-0 w-full text-sm inline-block h-[34px]"
                        data-te-select-wrapper-ref>
                        <select data-te-select-init data-te-select-placeholder="Select Item"
                            data-te-select-filter="true" name="" id="" v-model="selectedEvent" class="input-ui">
                            <option :value="event" v-for="(event, eventIndex) in eventList" :key="eventIndex">
                                {{ event.name }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-span-4" v-else></div>

                <div class="col-span-4">
                    <label for="" class="label-form mb-3">
                        Item Name
                    </label>
                    <div class="bg-white mb-0 w-full text-sm inline-block h-[34px]"
                        data-te-select-wrapper-ref>
                        <select data-te-select-init data-te-select-placeholder="Select Category"
                            data-te-select-filter="true" name="" id="" v-model="selectedItem" class="input-ui" @change="itemSelectChanged">
                            <option :value="item" v-for="(item, itemIndex) in itemList" :key="item.code">
                                {{ item.name }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-span-4">
                    <label for="" class="label-form mb-3">
                        Item Code
                    </label>
                    <div class="bg-white mb-0 w-full text-sm inline-block h-[34px]"
                        data-te-select-wrapper-ref>
                        <select data-te-select-init data-te-select-placeholder="Select Category"
                            data-te-select-filter="true" name="" id="" v-model="selectedItem" class="input-ui" @change="itemSelectChanged">
                            <option :value="item" v-for="(item, itemIndex) in itemList" :key="item.code">
                                {{ item.code }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-span-4">
                    <label for="" class="label-form mb-3">
                        Brand
                    </label>
                    <select name="" id="" v-model="selectedBrand" class="input-ui" @change="selectedBrandChange()">
                        <option :value="brand" v-for="(brand, brandIndex) in brandList" :key="brandIndex">
                            {{ brand.name }}
                        </option>
                    </select>

                </div>
                <div class="col-span-4 grid grid-rows-2 gap-y-8 gap-x-8">
                    <div class="row-span-1 col-span-2">
                        <label for="" class="label-form mb-3">
                            Base Qty
                        </label>
                        <input type="number" v-model="baseQuantity" class="input-ui" placeholder="Base Qty">
                    </div>
        
                    <div class="row-span-1 col-span-2">
                        <label for="" class="block text-sm text-black mb-3">
                            Base UOM Qty
                        </label>
                        <select name="" id="" v-model="selectedBaseUom" class="input-ui" disabled>
                            <option :value="uom" v-for="(uom, uomIndex) in itemUoms" :key="uomIndex">
                                {{ uom.name }}
                            </option>
                        </select>
                        <!-- <div class="bg-white mb-0 w-full text-xs h-8 border-b border-black rounded-bl-[4px] rounded-br-[4px] overflow-hidden inline-block"
                            data-te-select-wrapper-ref>
                            <select data-te-select-init data-te-select-placeholder="Select UOM" data-te-select-filter="true"
                                name="" id="" v-model="selectedUom"
                                class="">
                                <option :value="uom" v-for="(uom, uomIndex) in itemUoms" :key="uomIndex">
                                    {{ uom.name }}
                                </option>
                            </select>
                        </div> -->
                    </div>
        
                    <!-- <div class="col-span-1">
                        <label for="" class="label-form mb-3">
                            Qty    
                        </label>
                        <input type="number" v-model="quantity" class="input-ui" placeholder="Qty">
                    </div>
        
                    <div class="col-span-1">
                        <label for="" class="block text-sm text-black mb-3">
                            UOM
                        </label>
                        <select name="" id="" v-model="selectedUom" class="input-ui" disabled>
                            <option :value="uom" v-for="(uom, uomIndex) in itemUoms" :key="uomIndex">
                                {{ uom.name }}
                            </option>
                        </select>
                    </div> -->
                </div>
                <div class="col-span-4 row-span-2">
                    <label for="" class="block text-sm text-black mb-3">
                        Remark
                    </label>
                    <textarea v-model="remark" class="text-sm border border-gray-300 input-ui w-full bg-transparent rounded-lg focus:ring-0"
                         name="" id="" cols="30" rows="6"></textarea>
                </div>
                <div class="col-span-4 flex items-end">
                    <label for="" class="block text-sm text-black mb-3">
                        &nbsp;
                    </label>
                    <button class="add-btn" @click="addItemBtnClicked"> Add </button>
                </div>

            </div>
        </div>

        <div class="bg-white px-4 py-4 rounded-md shadow-md mb-8">
            <div class="table-container">
                <table class="primary-table">
                    <thead class="">
                        <tr>
                            <th scope="col" class="">
                                Item
                            </th>
                            <th scope="col" class="">
                                Brand
                            </th>
                            <th scope="col" class="">
                                Qty
                            </th>
                            <!-- <th scope="col" class="">
                                UOM
                            </th> -->
                            <th scope="col" class="">
                                Unit Price
                            </th>
                            <th scope="col" class="">
                                Total
                            </th>
                            <th scope="col" class="">

                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <div class="contents" v-for="(purchaseOrderItem, purchaseOrderItemsIndex) in purchaseOrderItems"
                            :key="purchaseOrderItemsIndex">
                            <tr class="">
                                <td class="">
                                    {{ purchaseOrderItem.name }}
                                </td>
                                <td class="">
                                    {{ purchaseOrderItem.brand_name }}
                                </td>
                                <td class="">
                                    {{ purchaseOrderItem.base_uom_quantity > 0 ? purchaseOrderItem.base_uom_quantity : '' }}{{ purchaseOrderItem.base_uom_quantity > 0 ? purchaseOrderItem.base_uom_name : '' }} 
                                    {{ purchaseOrderItem.uom_quantity > 0 ? purchaseOrderItem.uom_quantity : '' }} {{ purchaseOrderItem.uom_quantity > 0 ? purchaseOrderItem.uom_name : '' }}

                                    <!-- {{ purchaseOrderItem.base_uom_quantity }}{{ purchaseOrderItem.base_uom_name }}
                                    {{ purchaseOrderItem.uom_quantity }}{{ purchaseOrderItem.uom_name }} -->

                                     <!-- {{ purchaseOrderItem.quantity }} -->
                                </td>
                                <!-- <td class="">
                                    {{ purchaseOrderItem.uom_name }}
                                </td> -->
                                <td class="">
                                    {{ purchaseOrderItem.unit_price.toLocaleString() }} ({{ purchaseOrderItem.base_uom_name }})
                                </td>
                                <td class="">
                                    <!-- {{ (purchaseOrderItem.amount * purchaseOrderItem.quantity).toLocaleString() }} -->
                                    {{ purchaseOrderItem.amount.toLocaleString() }}

                                </td>
                                <td class="">
                                    <button @click="editQuantityBtnClicked(purchaseOrderItemsIndex)"
                                    data-te-toggle="modal" data-te-target="#editModal">
                                        <i class="fal fa-pen  pr-3"></i>
                                    </button>
                                    
                                    <button @click="removePurchaseOrderItemBtnClicked(purchaseOrderItemsIndex)"
                                    data-te-toggle="modal" data-te-target="#deleteModal">
                                        <i class="fal fa-trash  pr-3"></i>
                                    </button>
                                </td>
                            </tr>
                        </div>
                        <div class="contents">
                            <tr class="">
                                <td class="" colspan="5">
                                    &nbsp;
                                </td>
                                <td class="">
                                    {{ totalPrice.toLocaleString() }}
                                </td>
                            </tr>
                        </div>

                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div>
        <button class="add-btn" @click="editPurchaseOrderBtnClicked">
            Edit Purchase Order
        </button>
    </div>

    <!-- Modal -->
    <div data-te-modal-init class="fixed left-0 top-0 z-[1055] hidden h-full w-full overflow-y-auto overflow-x-hidden outline-none"
        id="editModal" tabindex="-1" aria-labelledby="create_modalLabel" aria-hidden="true">
        <div data-te-modal-dialog-ref class="pointer-events-none relative w-auto mb-12 translate-y-[-50px] opacity-0 transition-all duration-300 ease-in-out min-[576px]:mx-auto min-[576px]:mt-7 min-[576px]:max-w-[500px]">
            <div class="min-[576px]:shadow-[0_0.5rem_1rem_rgba(#000, 0.15)] pointer-events-auto relative flex w-full flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none">
                <div class="relative  p-4">
                    <!--Modal title-->
                    <h5 class="text-xl text-center mt-2 font-medium leading-normal text-black" id="create_modalLabel">
                        Edit Quantity
                    </h5>
                    <!--Close button-->
                    <button type="button" class="absolute top-4 right-4 focus:shadow-none focus:outline-none" @click="selectedItem = null"
                        data-te-modal-dismiss aria-label="Close" id="close_quantity_modal">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                            stroke="currentColor" class="h-5 w-5">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                <!--Modal body-->
                <div class="relative px-12 py-4" data-te-modal-body-ref>
                    
                    <div class="grid grid-cols-12 gap-x-4 w-full">
                        <div class="col-span-8 mb-4">
                            <label for="" class="label-form mb-3">
                                Base UOM Qty
                            </label>
                            <input type="number" v-model="baseQuantityEdit" class="input-ui" placeholder="Qty">
                        </div>
            
                        <div class="col-span-4 mb-4">
                            <label for="" class="block text-sm text-black mb-3">
                                Base UOM
                            </label>
                            <div class="bg-white mb-0 w-full text-xs h-full rounded-bl-[4px] rounded-br-[4px] overflow-hidden inline-block"
                                data-te-select-wrapper-ref>
                                <select data-te-select-init data-te-select-placeholder="Select UOM" disabled data-te-select-filter="true"
                                    name="" id="" v-model="selectedBaseUomEdit"
                                    class="input-ui">
                                    <option :value="uom" v-for="(uom, uomIndex) in itemUoms" :key="uomIndex">
                                        {{ uom.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="grid grid-cols-12 gap-x-4 w-full">
                        <div class=" col-span-8 mb-4">
                            <label for="" class="label-form mb-3">
                                Qty
                            </label>
                            <input type="number" v-model="quantityEdit" class="input-ui" placeholder="Qty">
                        </div>
            
                        <div class=" col-span-4 mb-4">
                            <label for="" class="block text-sm text-black mb-3">
                                UOM
                            </label>
                            <div class="bg-white mb-0 w-full text-xs h-auto rounded-bl-[4px] rounded-br-[4px] overflow-hidden inline-block"
                                data-te-select-wrapper-ref>
                                <select data-te-select-init data-te-select-placeholder="Select UOM" disabled data-te-select-filter="true"
                                    name="" id="" v-model="selectedUomEdit"
                                    class="">
                                    <option :value="uom" v-for="(uom, uomIndex) in itemUoms" :key="uomIndex">
                                        {{ uom.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    

                    <!-- <div class="mb-4">
                        <label for="" class="block text-sm text-black mb-3">
                            Quantity
                        </label>
                        <input type="number" placeholder="Quantity" v-model="editQuantity" class="text-sm border border-gray-300 input-ui w-full bg-transparent rounded-lg focus:ring-0">
                    </div> -->
                    <div class="mb-[0.125rem] block min-h-[1.5rem] pl-[1.5rem]">
                    <!-- <div v-if="!(getDepartment().name == 'HR' && isStaff)" class="mb-[0.125rem] block min-h-[1.5rem] pl-[1.5rem]"></div> -->
                        <input
                            @change="laterBuyToggled"
                            v-model="isLaterBuy"
                            class="relative float-left -ml-[1.5rem] mr-[6px] mt-[0.15rem] h-[1.125rem] w-[1.125rem] appearance-none rounded-[0.25rem] border-[0.125rem] border-solid border-neutral-300 outline-none before:pointer-events-none before:absolute before:h-[0.875rem] before:w-[0.875rem] before:scale-0 before:rounded-full before:bg-transparent before:opacity-0 before:shadow-[0px_0px_0px_13px_transparent] before:content-[''] checked:border-primary checked:bg-primary checked:before:opacity-[0.16] checked:after:absolute checked:after:-mt-px checked:after:ml-[0.25rem] checked:after:block checked:after:h-[0.8125rem] checked:after:w-[0.375rem] checked:after:rotate-45 checked:after:border-[0.125rem] checked:after:border-l-0 checked:after:border-t-0 checked:after:border-solid checked:after:border-white checked:after:bg-transparent checked:after:content-[''] hover:cursor-pointer hover:before:opacity-[0.04] hover:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:shadow-none focus:transition-[border-color_0.2s] focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-[0.875rem] focus:after:w-[0.875rem] focus:after:rounded-[0.125rem] focus:after:content-[''] checked:focus:before:scale-100 checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] checked:focus:after:-mt-px checked:focus:after:ml-[0.25rem] checked:focus:after:h-[0.8125rem] checked:focus:after:w-[0.375rem] checked:focus:after:rotate-45 checked:focus:after:rounded-none checked:focus:after:border-[0.125rem] checked:focus:after:border-l-0 checked:focus:after:border-t-0 checked:focus:after:border-solid checked:focus:after:border-white checked:focus:after:bg-transparent dark:border-neutral-600 dark:checked:border-primary dark:checked:bg-primary dark:focus:before:shadow-[0px_0px_0px_13px_rgba(255,255,255,0.4)] dark:checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca]"
                            type="checkbox"
                            value=""
                            :checked="isLaterBuy"
                            id="checkboxDefault" />
                        <label
                            class="inline-block pl-[0.15rem] hover:cursor-pointer"
                            for="checkboxDefault">
                            Later Buy
                        </label>
                    </div>
                </div>

                <!--Modal footer-->
                <div class="flex justify-center px-12 mb-6">
                    <button type="button" @click="confirmEditQuantityBtnClicked()" class="add-btn focus:outline-none focus:ring-0 "
                        >
                        Edit
                    </button>
                </div>
            </div>
        </div>
    </div>
    <!--Delete Modal -->
    <div data-te-modal-init class="fixed left-0 top-0 z-[1055] hidden h-full w-full overflow-y-auto overflow-x-hidden outline-none"
        id="deleteModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div data-te-modal-dialog-ref class="pointer-events-none relative flex min-h-[calc(100%-1rem)] w-auto translate-y-[-50px]
            items-center opacity-0 transition-all duration-300 ease-in-out min-[576px]:mx-auto min-[576px]:mt-7
            min-[576px]:min-h-[calc(100%-3.5rem)] min-[576px]:max-w-[500px]">
            <div class="min-[576px]:shadow-[0_0.5rem_1rem_rgba(#000, 0.15)] pointer-events-auto relative flex w-full flex-col
                rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none ">
                <div class="flex flex-shrink-0 items-center justify-between rounded-t-md border-b-2 border-neutral-100 border-opacity-100 p-4 ">
                    <!--Modal title-->
                    <h5 class="text-xl font-medium leading-normal text-neutral-800 " id="exampleModalLabel">
                        Delete ?
                    </h5>
                    <!--Close button-->
                    <button type="button" class="box-content rounded-none border-none hover:no-underline hover:opacity-75 focus:opacity-100 focus:shadow-none focus:outline-none" data-te-modal-dismiss aria-label="Close">
                        <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                <!--Modal body-->
                <div class="relative flex-auto p-4" data-te-modal-body-ref>
                    <p>
                        Are you sure ?
                    </p>
                </div>

                <!--Modal footer-->
                <div class="flex flex-shrink-0 flex-wrap items-center justify-end rounded-b-md border-t-2 border-neutral-100 border-opacity-100 p-4 ">
                    <button type="button" class="inline-block px-6 pb-2 pt-2.5 text-xs focus:outline-none focus:ring-0 " data-te-modal-dismiss>
                        Close
                    </button>
                    <button @click="confirmRemovePurchaseOrderItemBtnClicked" type="button" data-te-toggle="modal" data-te-target="#deleteModal"
                    class="ml-1 inline-block rounded bg-red-600 px-6 pb-2 pt-2.5 text-xs  text-white   focus:outline-none focus:ring-0 ">
                        Delete
                    </button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import { initTE, Select, Dropdown } from "tw-elements";
    import { getApiData, postApiData, deleteApiData } from '../../utilities/ajax-helpers';
    import { getCurrentDate } from '../../utilities/datetime-helpers';
    import { mapGetters } from "vuex";

    export default {
        props: ['poId'],
        data() {
            return {
                date: getCurrentDate(),
                itemList: [],
                selectedItem: null,
                brandList:[],
                selectedBrand:null,

                uomList: [],
                itemUoms: [],
                selectedUom: null,
                quantity: 0,
                selectedBaseUom: null,
                baseQuantity: 0,
                purchaseOrderItems: [],
                remark: null,

                unitPrice:null,
                totalPrice: 0,

                poDetail:null,

                isLaterBuy: false,
                selectedUomEdit: null,
                quantityEdit: null,
                selectedBaseUomEdit: null,
                baseQuantityEdit: null,
                editPurchaseOrderItem: null,
                isLaterBuy:false,

                deleteId:null,
                deleteIndex:null,

                typeList:[
                    {'name': 'KTV', 'value': 'ktv'},
                    {'name': 'Restaurant', 'value': 'restaurant'},
                    {'name': 'Bar', 'value': 'bar'},
                    {'name': 'Event', 'value': 'event'},
                ],
                selectedType: null,
                eventList: [],
                selectedEvent: null,
            };
        },

        methods: {
            ...mapGetters(['getToken']),
            async getEventList(){
                let response = await getApiData({url: `/api/events`, token: this.getToken()});
                if(response.data){
                    this.eventList = response.data;
                }
            },
            async getPoDetail(){
                let response = await getApiData({url: `/api/purchase_orders/${this.poId}`, token: this.getToken()});
                if(response.data){
                    this.poDetail = response.data;
                    this.addDetail(response.data);
                    // this.date = this.purchaseOrder.date;
                    // this.purchaseOrderItems = this.purchaseOrder.items;
                    // this.updateTotalPrice(this.purchaseOrderItems);
                }
            },
            addDetail(detail){
                this.date = this.poDetail.date;
                this.selectedType = this.typeList.find(type => type.value === detail.type);
                this.selectedEvent = this.eventList.find(event => event.id = detail.event_id)
                this.poDetail.items.forEach(po => {
                    // let quantity = (po.base_uom_quantity * po.uom_conversion.conversion) + po.uom_quantity
                    // let price = ((po.base_uom_quantity * po.uom_conversion.conversion) + po.uom_quantity) * po.item.average_price
                    // let price = quantity * po.unit_price;
                    // let big_uom_quantity = Math.floor(quantity / po.uom_conversion.conversion);
                    // let small_uom_quantity = quantity % po.uom_conversion.conversion;
                    this.purchaseOrderItems.push({
                        id:po.id,
                        item_id: po.item_id,
                        brand_name:po.brand.name,
                        brand_id:po.brand_id,
                        quantity: po.quantity,
                        amount: po.amount,
                        unit_price: po.unit_price,
                        uom_id: po.uom_id,
                        uom_quantity: po.uom_quantity,
                        uom_name: po.uom.name,
                        uom_conversion_id: po.uom_conversion_id,
                        base_uom_id: po.base_uom_id,
                        base_uom_quantity: po.base_uom_quantity,
                        base_uom_name: po.base_uom.name,
                        name: po.item.name,
                        remark: po.remark,
                        // small_quantity: small_uom_quantity,
                        // big_quantity: big_uom_quantity
                    });
                });
                this.updateTotalPrice(this.purchaseOrderItems);
            },
            async getItemList(){
                let response = await getApiData({url: `/api/items`, token: this.getToken()});
                if(response.data){
                    this.itemList = response.data;
                }
            },

            async getUomList() {
                let response = await getApiData({ url: `/api/uoms`, token: this.getToken() });
                if (response.data) {
                    this.uomList = response.data;
                    console.log(response.data);
                }
            },

            itemSelectChanged(){
                this.itemUoms = [];
                let index = this.uomList.findIndex(uom => uom.id == this.selectedItem.base_uom_id);
                if(index != -1){
                    let baseUom = this.uomList[index];
                    this.itemUoms.push(baseUom);
                }
                index = this.uomList.findIndex(uom => uom.id == this.selectedItem.uom_id);
                if(index != -1){
                    let itemUom = this.uomList[index];
                    this.itemUoms.push(itemUom);
                }
                this.selectedUom = this.itemUoms.find(uom => uom.id == this.selectedItem.uom_id)
                this.selectedBaseUom = this.itemUoms.find(uom => uom.id == this.selectedItem.base_uom_id)
                this.brandList = this.selectedItem.brands;
            },
            async selectedBrandChange(){
                console.log('brand change')
                let response = await getApiData({url: '/api/items/' + this.selectedItem.id + '/brands/' + this.selectedBrand.id, token: this.getToken()});
                if(response.data){
                    this.unitPrice = response.data;
                    console.log(response)
                }
            },
            alertValidationMessage(field){
                this.$notify({
                    title: 'Input validation',
                    text: `You forgot to prvide ${field}, please try again`,
                    type: 'warn'
                });
            },

            async addItemBtnClicked(){
                if(!this.selectedItem){
                    this.alertValidationMessage('an item');
                    return 1;
                }
                if(!this.selectedUom){
                    this.alertValidationMessage('a uom');
                    return 1;
                }
                if(this.baseQuantity < 1){
                    this.alertValidationMessage('quantity');
                    return 1;
                }
                if(!this.selectedBaseUom){
                    this.alertValidationMessage('base uom');
                    return 1;
                }
                let floatItemPrice = parseFloat(this.selectedItem.average_price)
                // amount = (this.selectedItem.item_prices)? this.selectedItem.item_prices.price: 0;
                let quantity = (this.baseQuantity * this.selectedItem.uom_conversion) + this.quantity
                // let price = ((this.baseQuantity * this.selectedItem.uom_conversion) + this.quantity) * this.selectedItem.average_price
                let price = quantity * (this.unitPrice / this.selectedItem.uom_conversion);
                let isLimitExceed = 0;
                let formData = new FormData();
                formData.append('item_id', this.selectedItem.id);
                formData.append('base_uom_quantity', this.baseQuantity);
                formData.append('uom_quantity', this.quantity);
                formData.append('amount', price);
                let response = await postApiData({ url: '/api/purchase_orders_items/check_limitation', form_data: formData, token: this.getToken() });
                if (response.success) {
                    isLimitExceed = 0;
                    // document.getElementById('close_create_modal').click();
                    // this.limitWarning = null;
                }
                else {
                    isLimitExceed = 1;
                    this.$notify({
                        title: `Input validation`,
                        text: response.message,
                        type: "error"
                    });
                    // this.limitWarning = response.message;
                }

                if(this.purchaseOrderItems.some((item) => item.item_id === this.selectedItem.id && item.brand_id === this.selectedBrand.id) && this.purchaseOrderItems.length > 0){
                    let index = this.purchaseOrderItems.findIndex(item => item.item_id == this.selectedItem.id && item.brand_id == this.selectedBrand.id)
                    this.purchaseOrderItems[index].quantity += quantity;
                    this.purchaseOrderItems[index].amount += price;
                    this.purchaseOrderItems[index].uom_quantity += this.quantity;
                    this.purchaseOrderItems[index].base_uom_quantity += this.baseQuantity;
                }
                else{
                    this.purchaseOrderItems.push({
                        item_id: this.selectedItem.id,
                        brand_id: this.selectedBrand.id,
                        brand_name: this.selectedBrand.name,
                        quantity: quantity,
                        amount: price,
                        // unit_price: this.unitPrice / this.selectedItem.uom_conversion,
                        unit_price: this.unitPrice,
                        uom_id: this.selectedUom.id,
                        uom_quantity: this.quantity,
                        uom_name: this.selectedUom.name,
                        uom_conversion_id: this.selectedItem.uom_conversion_id,
                        base_uom_id: this.selectedBaseUom.id,
                        base_uom_quantity: this.baseQuantity,
                        base_uom_name: this.selectedBaseUom.name,
                        name: this.selectedItem.name,
                        remark: this.remark,
                        is_exceed_max_limitation: isLimitExceed
                    });
                }
                

                this.updateTotalPrice(this.purchaseOrderItems);
                this.selectedItem = null;
                this.selectedUom = null;
                this.quantity = 0;
                this.selectedBaseUom = null;
                this.baseQuantity = 0;
                this.selectedBrand = null;
                this.remark = null;
            },
            editQuantityBtnClicked(purchaseOrderItemsIndex){
                this.editPurchaseOrderItem = this.purchaseOrderItems[purchaseOrderItemsIndex];
                console.log(this.editPurchaseOrderItem);
                if(this.editPurchaseOrderItem.later_buy == 1){
                    this.isLaterBuy = true;
                }
                else{
                    this.isLaterBuy = false;
                }
                this.selectedItem = this.itemList.find(item => item.id == this.editPurchaseOrderItem.item_id);
                this.itemSelectChanged();
                this.selectedUomEdit = this.itemUoms.find(uom => uom.id == this.editPurchaseOrderItem.uom_id);
                this.selectedBaseUomEdit = this.itemUoms.find(uom => uom.id == this.editPurchaseOrderItem.base_uom_id);
                this.quantityEdit = this.editPurchaseOrderItem.uom_quantity;
                this.baseQuantityEdit = this.editPurchaseOrderItem.base_uom_quantity;

            },
            confirmEditQuantityBtnClicked(){
                let index = this.purchaseOrderItems.findIndex(poItem => poItem.id == this.editPurchaseOrderItem.id);
                if(index != -1){
                    this.purchaseOrderItems[index].uom_quantity = this.quantityEdit;
                    this.purchaseOrderItems[index].base_uom_quantity = this.baseQuantityEdit;
                    this.purchaseOrderItems[index].quantity = (this.baseQuantityEdit * this.selectedItem.uom_conversion) + this.quantityEdit
                    this.purchaseOrderItems[index].amount = ((this.baseQuantityEdit * this.selectedItem.uom_conversion) + this.quantityEdit) * this.purchaseOrderItems[index].unit_price
                    this.purchaseOrderItems[index].later_buy = (this.isLaterBuy)? 1: 0;
                    console.log(this.purchaseOrderItems[index].price);
                }

                this.updateTotalPrice(this.purchaseOrderItems);
                this.quantityEdit = null;
                this.baseQuantityEdit = null;
                this.editPurchaseOrderItem = null;
                this.isLaterBuy = false;
                this.selectedItem = null;
                document.getElementById("close_quantity_modal").click();
            },
            removePurchaseOrderItemBtnClicked(purchaseOrderItemsIndex){
                if(this.purchaseOrderItems[purchaseOrderItemsIndex].id){
                    this.deleteId = this.purchaseOrderItems[purchaseOrderItemsIndex].id;
                }
                this.deleteIndex = purchaseOrderItemsIndex;
            },

            async confirmRemovePurchaseOrderItemBtnClicked(){
                if(this.deleteId){
                    let url = `/api/purchase_orders_items/${this.deleteId}`;
                    let response = await deleteApiData({url: url, token: this.getToken()});
                    if(response.success){
                        this.purchaseOrderItems.splice(this.deleteIndex, 1);
                    }
                }
                else{
                    this.purchaseOrderItems.splice(this.deleteIndex, 1);
                }
                this.updateTotalPrice(this.purchaseOrderItems);
                this.deleteId = null;
                this.deleteIndex = null;
            },

            async editPurchaseOrderBtnClicked(){
                if(!this.date){
                    this.alertValidationMessage('Date');
                    return 1;
                }
                if(!this.selectedType){
                    this.alertValidationMessage('Type');
                    return 1;
                }
                if(this.selectedType.value === 'event' && !this.selectedEvent){
                    this.alertValidationMessage('Event');
                    return 1;
                }
                if(this.purchaseOrderItems.length<1){
                    this.alertValidationMessage('Items');
                    return 1;
                }
                let priceTotal = 0;
                this.purchaseOrderItems.forEach((purchaseOrderItem)=>{
                    priceTotal += purchaseOrderItem.price;
                });
                let formData = new FormData();
                formData.append('id', this.poId);
                formData.append('date', this.date);
                formData.append('type', this.selectedType.value);
                if(this.selectedType.value === 'event'){
                    formData.append('event_id', this.selectedEvent.id);
                }
                formData.append('total_price', priceTotal);
                formData.append('items', JSON.stringify(this.purchaseOrderItems));
                let response = await postApiData({url: `/api/purchase_orders`, form_data:  formData, token: this.getToken()});
                if(response.success){
                    this.$notify({
                        text: `A new purchase order created`,
                        type: 'info'
                    });
                    window.location.replace(`/purchase_orders`);
                    // setTimeout(()=>{
                    //     window.location.replace(`/purchase_orders`);
                    // }, 3000);
                }
                else{
                    this.$notify({
                        text: `Some errors occurred`,
                        type: 'error'
                    });
                }
            },

            updateTotalPrice(poItems){
                this.totalPrice = 0;
                poItems.forEach((item)=>{
                    this.totalPrice += item.amount;
                });
            },

        },

        created(){
            this.getItemList();
            this.getEventList();
            this.getUomList();
            this.getPoDetail();
        },

        mounted(){
            initTE({Select, Dropdown});
        }
    }
</script>
